import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorEndedBots = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M12.75 4.291a1.636 1.636 0 1 0-1.5 0v4.073h1.5V4.29Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M2.25 10.3A2.75 2.75 0 0 1 5 7.55h14a2.75 2.75 0 0 1 2.75 2.75v9A2.75 2.75 0 0 1 19 22.05H5a2.75 2.75 0 0 1-2.75-2.75v-9ZM5 9.05c-.69 0-1.25.56-1.25 1.25v9c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-9c0-.69-.56-1.25-1.25-1.25H5Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M12 11.25a.75.75 0 0 1 .75.75v3.25H16a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75v-4a.75.75 0 0 1 .75-.75Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorEndedBots;
